import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	flight: {
		margin: 0,
	},
	flights: {
		display: 'flex',
		flexDirection: 'column',
		gap: `calc(${theme.spacing.small} * 2)`,

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
			gap: `calc(${theme.spacing.xlarge} * 2)`,
		},

		'& > div': {
			position: 'relative',
			flex: '1',

			'&:not(:first-of-type):before': {
				position: 'absolute',
				content: '" "',
				background: theme.divider.color,
				top: `calc(${theme.spacing.small} * -1)`,
				width: '100%',
				height: 1,

				[getFromBreakpoint('md')]: {
					top: 0,
					width: 1,
					left: `calc(${theme.spacing.xlarge} * -1)`,
					height: '100%',
				},
			},
		},
	},
	flightSection: {
		marginTop: theme.spacing.small,
		paddingTop: theme.spacing.small,
		borderTop: theme.divider.border,
	},
	flightExtras: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xsmall,
	},
	offerSummaryWrapper: {
		display: 'flex',

		'&> div': {
			flexGrow: 1,
			flexBasis: 0,
			height: 'min-content',
		},

		[getFromBreakpoint('lg')]: {
			margin: `${theme.spacing.small} ${theme.spacing.jumbo} 0 ${theme.spacing.jumbo}`,
			columnGap: theme.spacing.xlarge,
		},
	},
}));
